module.exports = __webpack_public_path__ + "static/media/loading.5001252b.gif";